import { render, staticRenderFns } from "./QRScan.vue?vue&type=template&id=7fa9f910&"
import script from "./QRScan.vue?vue&type=script&lang=ts&"
export * from "./QRScan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports